import type { ActiveGeneration } from '~/lib/api/chats';

/**
 * True when the server still reports OUR chat as generating — meaning the
 * local stream ended without a finish frame because the connection dropped
 * (network blip, mid-turn studio deploy), not because the turn completed.
 * A completed turn clears the active-stream marker before the response ends,
 * so a normal finish sees `active` as null (or another chat's turn).
 */
export function isOurTurnStillRunning(active: ActiveGeneration | null, chatId: string | undefined): boolean {
  if (!active || !chatId) {
    return false;
  }

  return active.id === chatId || active.urlId === chatId;
}

/**
 * The outcome of asking the server what it is generating.
 *
 * Three-valued on purpose. "No turn is running" and "I could not ask" are
 * opposite facts, and collapsing them into a bare `null` is what rendered a
 * 19-second client-side network blip as a red "Server Error" over a build that
 * finished fine 12 seconds later (2026-09-20, chat 21276421). When `reachable`
 * is false the server was never asked, so `active` carries no verdict about it
 * and callers must not read one into it.
 */
export interface ActiveGenerationProbe {
  reachable: boolean;
  active: ActiveGeneration | null;
}
